<template>
  <div class="hello">
    <b-row>
    <a-menu
      style="width: 256px"
      :default-selected-keys="['1']"
      :open-keys.sync="openKeys"
      mode="inline"
      @click="handleClick"
    >
      <a-sub-menu key="sub1" class="menu" @titleClick="titleClick">
        <span slot="title" class="menu-item"><img class="nav-gif" src="img/proj.gif" /><strong>EBO</strong></span>
        <a-menu-item-group key="g1">
          <template slot="title"><img class="nav-gif" src="img/docs.gif" /><span>Document(22)</span> </template>
          <a-menu-item key="1">
            <img src="img/mdl.gif" /> Masters
          </a-menu-item>
          <a-menu-item key="2">
            <img src="img/mdl.gif" /> MODULE
          </a-menu-item>
          <a-sub-menu key="sub3">
            <template slot="title"><img class="" src="img/mdl.gif" /><span> Purchase</span> </template>
            <a-sub-menu key="sub4" class="last-sub">
            <template slot="title"><img class="" src="img/submdl.gif" /><span>Transaction</span> </template>
              <a-menu-item key="7">
                <img src="img/docimg.gif" /> BlanketPurchase
              </a-menu-item>
              <a-menu-item key="8">
                <img src="img/docimg.gif" /> Customer
              </a-menu-item>
              <a-menu-item key="9">
                <img src="img/docimg.gif" /> Department
              </a-menu-item>
              <a-menu-item key="10">
                <img src="img/docimg.gif" /> Employee
              </a-menu-item>
              <a-menu-item key="11">
                <img src="img/docimg.gif" /> ExciseDuty
              </a-menu-item>
              <a-menu-item key="12">
                <img src="img/docimg.gif" /> Expenses
              </a-menu-item>
              <a-menu-item key="13">
                <img src="img/docimg.gif" /> GoodsInwardN
              </a-menu-item>
              <a-menu-item key="14">
                <img src="img/docimg.gif" /> GoodsInwardR
              </a-menu-item>
              <a-menu-item key="15">
                <img src="img/docimg.gif" /> Item
              </a-menu-item>
              <a-menu-item key="16">
                <img src="img/docimg.gif" /> ItemGroup
              </a-menu-item>
              <a-menu-item key="17">
                <img src="img/docimg.gif" /> PaymentTerms
              </a-menu-item>
              <a-menu-item key="18">
                <img src="img/docimg.gif" /> PurchaseInvoice
              </a-menu-item>
              <a-menu-item key="19">
                <img src="img/docimg.gif" /> PurchaseOrder
              </a-menu-item>
              <a-menu-item key="20">
                <img src="img/docimg.gif" /> PurchaseReminder
              </a-menu-item>
              <a-menu-item key="21">
                <router-link :to="{ name: 'Purchase_Req'}"><img src="img/docimg.gif" /> PurchaseRequisition</router-link>
              </a-menu-item>
              <a-menu-item key="22">
                <img src="img/docimg.gif" /> PurchaseReturn
              </a-menu-item>
              <a-menu-item key="23">
                <img src="img/docimg.gif" /> PurchaseRFO
              </a-menu-item>
              <a-menu-item key="24">
                <img src="img/docimg.gif" /> UOM
              </a-menu-item>
              <a-menu-item key="24">
                <img src="img/docimg.gif" /> VendorParts
              </a-menu-item>
            </a-sub-menu>
          </a-sub-menu>
        </a-menu-item-group>
      </a-sub-menu>
    </a-menu>
  </b-row>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      current: ['mail'],
      openKeys: ['sub1'],
    };
  },
  watch: {
    openKeys(val) {
      console.log('openKeys', val);
    },
  },
  methods: {
    handleClick(e) {
      console.log('click', e);
    },
    titleClick(e) {
      console.log('titleClick', e);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-gif{
    margin-right: 5px;
    margin-top: -10px;
    width: 18px;
}
.ant-menu .last-sub .ant-menu-item, .ant-menu .last-sub .ant-menu-item-selected{
  text-align: left;
  padding-left: 150px !important;
}

</style>
